import { AHText } from "arkh";
import React from "react";
import { View } from "react-native";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { TodoListItemMainContentText_todo$key } from "./__generated__/TodoListItemMainContentText_todo.graphql";
import { opacityForStatus } from "./opacityForStatus";
import { FormattedMessage } from "react-intl";

export function TodoListItemMainContentText(props: {
  todo: TodoListItemMainContentText_todo$key;
}) {
  const todo = useFragment(
    graphql`
      fragment TodoListItemMainContentText_todo on Todo {
        title
        isIssue
        status
      }
    `,
    props.todo
  );
  const issuePlaceholder = todo.isIssue && todo.title === "";

  return (
    <View
      style={{
        flex: 1,
        alignItems: "center",
        flexDirection: "row",
        opacity: opacityForStatus(todo.status),
      }}
      pointerEvents="none"
    >
      <AHText
        spaceHorizontal="small"
        type="title-small"
        color={issuePlaceholder ? "text-washed" : undefined}
        numberOfLines={1}
        style={{ flex: 1 }}
      >
        {issuePlaceholder ? (
          <FormattedMessage
            defaultMessage="Issue"
            description="Issue placeholder"
          />
        ) : (
          todo.title
        )}
      </AHText>
    </View>
  );
}
